import React from 'react';
import { motion } from 'framer-motion';
import Exporting from '../assets/exportings.mp4';
import BackToHomeButton from './BackToHomeButton';


const Export = () => {
  return (
    <div className="relative w-full min-h-screen flex flex-col justify-between">
      {/* Video Background - Responsive */}
      <video 
        autoPlay 
        loop 
        muted 
        className="absolute top-0 left-0 w-full h-full object-cover brightness-50 z-0"
      >
        <source src={Exporting} type="video/mp4" />
      </video>
      

      {/* Content Container */}
      <div className="relative z-10 flex flex-col items-center justify-center text-white p-6 min-h-screen">
        
        {/* Back to Home Button at Top-Left */}
        <div className="absolute top-4 left-4">
          <BackToHomeButton />
        </div>

        {/* Animated Text - Our Exporting Locations */}
        <motion.h1 
          className="text-center font-bold text-3xl md:text-5xl mt-12"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          Our  Selling Locations
        </motion.h1>
      </div>

      {/* Footer */}
      
    </div>
  );
};

export default Export;
